export enum EditCompanyModalTab {
    Company = 'company',
    Leads = 'leads',
    Opportunities = 'opportunities',
    Offers = 'offers',
    Reservations = 'reservations',
    ActivityLog = 'activity_log',
    CreateOffer = 'create_offer',
}